import script from "./ReportTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportTable.vue?vue&type=script&setup=true&lang=js"

import "./ReportTable.vue?vue&type=style&index=0&id=3203bd46&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3203bd46"]])

export default __exports__